export default function abbreviateNumber(num, lowerBound = 10000) {
	num = Number(num);
	if (num < lowerBound) return num.toFixed();

	let abbreviations = [
		{ exp: 12, abbr: 'T' },
		{ exp: 9,  abbr: 'B' },
		{ exp: 6,  abbr: 'M' },
		{ exp: 3,  abbr: 'K' },
		{ exp: 0,  abbr: '' }
	];

	for (let i = 0; i < abbreviations.length; i++) {
		let { exp, abbr } = abbreviations[i];
		if (num >= Math.pow(10, exp)) {
			let factor = 1;
			let decimals = 0;

			num = num / Math.pow(10, exp);
			if (num < 10) {
				factor = 100;
				decimals = 2;
			} else if (num < 100) {
				factor = 10;
				decimals = 1;
			}

			num = num * factor;
			num = Number(Math.round(num) / factor).toFixed(decimals);

			// dont let the last decimal be '0'
			if (num.indexOf('.') !== -1) {
				while (decimals > 0 && num.slice(-1) === '0') {
					decimals -= 1;
					num = num * factor;
					num = Number(Math.round(num) / factor).toFixed(decimals);
				}
			}

			return num + abbr;
		}
	}

	return num;
}
